<template>
  <div>
    <div class="mb-5 ml-10">
      <v-switch
        v-model="enableShareReport"
        color="primary"
        inset
        hide-details
        class="ma-0 ml-3"
        label="I have Supplier Information"
      />
    </div>

    <template v-if="enableShareReport">
      <h3 class="mb-5">Supplier Information</h3>

      <v-row>
        <v-col cols="3">
          <v-text-field
            label="Supplier Name"
            v-model="form.supplier_name"
            dense
            outlined
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            label="Supplier Email"
            v-model="form.supplier_email"
            dense
            outlined
            type="email"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            label="Supplier Phone"
            v-model="form.supplier_phone"
            dense
            outlined
          />
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            :label="$t('profileSetting.selectCountry')"
            :placeholder="$t('profileSetting.selectCountry')"
            clearable
            v-model="form.supplier_country"
            item-text="translatedName"
            item-value="name"
            dense
            chips
            outlined
            :items="countries"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { getAllCountries } from "@/constants/countries";
import { has } from "lodash";

export default {
  name: "ReportDetailSupplierInfoComponent",

  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      countries: [],
      form: {
        supplier_name: "",
        supplier_email: "",
        supplier_phone: "",
        supplier_country: "",
      },
      manualToggle: null,
    };
  },

  computed: {
    hasSupplierInfo() {
        return ["supplier_name", "supplier_email", "supplier_phone", "supplier_country"]
            .some((key) => has(this.report, key) && !!this.report[key]);
     },

    // Toggle switch logic
    enableShareReport: {
      get() {
       if (this.manualToggle === null) {
          return this.hasSupplierInfo;
        }
        return this.manualToggle;
      },
      set(value) {
        this.manualToggle = value;

        if (!value) {
          // Clear form if disabled
          this.form = {
            supplier_name: "",
            supplier_email: "",
            supplier_phone: "",
            supplier_country: "",
          };
          this.emitUpdatedField();
        }else{
            // Populate form from props if available
            Object.assign(this.form, {
                supplier_name: this.report?.supplier_name,
                supplier_email: this.report?.supplier_email,
                supplier_phone: this.report?.supplier_phone,
                supplier_country: this.report?.supplier_country,
            });
            this.emitUpdatedField();
        }
      },
    },
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.emitUpdatedField();
      },
    },
  },

  methods: {
    loadCountries() {
      const lang = localStorage.getItem("LANGUAGE");
      this.countries = getAllCountries(lang);
    },

    emitUpdatedField() {
      this.$emit("updatedField", { ...this.form });
    },
  },

  mounted() {
    this.loadCountries();
    Object.assign(this.form, {
      supplier_name: this.report?.supplier_name,
      supplier_email: this.report?.supplier_email,
      supplier_phone: this.report?.supplier_phone,
      supplier_country: this.report?.supplier_country,
    });

    this.emitUpdatedField();
  },
};
</script>

<style scoped>
.ml-10 {
  margin-left: -10px !important;
}
</style>
